import { Container } from './Container';
import { SubmitButton } from './SubmitButton';
import { SubmitLoading } from './SubmitLoading';
import { SubmitIconComponent } from './SubmitIcon';
import { SubmitTextComponent } from './SubmitText';

export default {
  Container,
  SubmitButton,
  SubmitLoading,
  SubmitIcon: SubmitIconComponent,
  SubmitText: SubmitTextComponent,
};
